<template>
  <div>
    <b-modal
      id="pcontact"
      size="xl"
      class="fondoGrisClaro"
      hide-footer
      :title="title"
      no-fade
      scrollable
      centered
    >
      <b-container fluid>
        <b-form id="fcontact">
          <b-row>
            <b-col
              lg="4"
              md="6"
              sm="12"
            >
              <b-form-input
                id="NOMBRE"
                v-model="form.NOMBRE" 
                class="mt-1"
                name="NOMBRE"
                :placeholder="$t('fname')"
                required
              />
              <b-form-select
                id="PARTICULAR_EMPRESA"
                v-model="form.PARTICULAR_EMPRESA"
                class="mt-1"
                name="PARTICULAR_EMPRESA"
                :options="fcompany"    
                required        
              />
              <b-form-select
                id="TIPO_EMPRESA"
                v-model="form.TIPO_EMPRESA"
                class="mt-1"
                name="TIPO_EMPRESA"
                :options="fcompanySize"     
                required       
              />
            </b-col>
            <b-col
              lg="4"
              md="6"
              sm="12"
            >
              <b-row class="mt-1">
                <b-col cols="4">
                  <b-form-select
                    id="SMS__COUNTRY_CODE"
                    v-model="form.SMS__COUNTRY_CODE"
                    name="SMS__COUNTRY_CODE"
                    :options="code"     
                    required       
                  />
                </b-col>
                <b-col cols="8">
                  <b-form-input
                    id="SMS" 
                    v-model="form.SMS"
                    type="number"
                    name="SMS"
                    :placeholder="$t('ftelef')"
                    required
                  />
                </b-col>
              </b-row>
              <b-form-input
                id="EMAIL"
                v-model="form.EMAIL" 
                class="mt-1"
                type="email"
                name="EMAIL"
                :placeholder="$t('femail')"
                required
              />
              <b-form-input
                id="CIUDAD"
                v-model="form.CIUDAD" 
                class="mt-1"
                :placeholder="$t('fcuidad')"
                name="CIUDAD"
                required
              />
            </b-col>
            <b-col
              lg="4"
              md="6"
              sm="12"
            >
              <b-form-textarea
                id="COMENTARIOS"
                v-model="form.COMENTARIOS" 
                class="mt-1"
                :placeholder="$t('fcomentarios')"
                rows="3"
                style="height: 7.5em"
                no-resize
                name="COMENTARIOS"
                required
              />
            </b-col>
            <b-col
              md="12"
              sm="12"
              class="rgpd"
              id="rgpd"
            >
            <p>{{ $t("rgpd.youcan") }} <a target="_blank" href="https://www.aicad.es/page/aviso-legal-privacidad/">{{ $t("rgpd.policy_capt") }}</a> </p>
            <p><strong>{{ $t("rgpd.resp_capt") }}</strong>: {{ $t("rgpd.resp_answ") }}</p>
            <p><strong>{{ $t("rgpd.final_capt") }}</strong>: {{ $t("rgpd.final_answ") }}</p>
            <p><strong>{{ $t("rgpd.stora_capt") }}</strong>: {{ $t("rgpd.stora_anws") }}</p>
            <p><strong>{{ $t("rgpd.right_capt") }}</strong>: {{ $t("rgpd.right_answ1") }} <a target="_blank" href="https://www.aicad.es/page/aviso-legal-privacidad/">{{ $t("rgpd.right_answ2") }}</a></p>
            </b-col>
            <b-col
              md="6"
              sm="12"
              class="pt-1"
            >
              <b-form-checkbox
                id="RGPD_OPTIN"
                v-model="form.RGPD_OPTIN"
                name="RGPD_OPTIN"
                class="mt-1"
                value="1" 
                unchecked-value="0"
                @change="aceptPolitica"
              >
                <span>
                  {{ $t("facept1") }}
                </span>
                <a
                  :href="url"
                  target="_blank"
                >
                  {{ $t("facept2") }}
                </a>
              </b-form-checkbox>
            </b-col>
            <b-col
              md="6"
              sm="12"
              class="pt-1 text-right"
            >
              <b-button
                class="buttonContacto"
                type="submit"
                :disabled="enviar==0"
                @click="enviarFormulario()"
              >
                {{ $t("btnEnviar") }}
                <font-awesome-icon
                  :icon="['fas','angle-right']"
                  class="ml-2"
                  size="lg"
                />
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </b-modal>
  </div>
</template>

<i18n>
{
  "en":{
    "title": "Contact us"
    , "fname": "Name"
    , "fcompany": [
      {"value": null, "text": "Select type of Company", "disabled": true}
      , {"value": "Particular","text": "Particular"}
      , {"value": "Empresa","text": "Company"}
    ]
    , "fcompanySize": [
      {"value": null, "text": "Select company category", "disabled": true}
      ,{"value": "Autonomo o Pequeña Empresa","text": "Freelance or Small Business"}
      ,{"value": "Mediana / Gran Empresa","text": "Medium / Large Company"}
      ,{"value": "Asesorías y Consultora","text": "Consulting and Consultant"}
      ,{"value": "Otros","text": "Others"}
    ]
    , "ftelef": "Phone"
    , "femail": "Email"
    , "fcuidad": "City or Town"
    , "fcomentarios": "Tell us how we can help you ....."
    , "facept1": "I have read and accept the terms "
    , "facept2": "of privacy*"
    , "btnEnviar": "Submit"
    , "sendOK": "Message sent"
    , "sendERROR": "Message delivery failed"
    , "message.rs": "Internships"
    , "rgpd.youcan": "You can consult the additional and detailed information on Data Protection in our"
    , "rgpd.policy_capt": "Privacy Policy"
    , "rgpd.resp_capt": "Responsible for the treatment"
    , "rgpd.resp_answ": "Aicad Business School S.L."
    , "rgpd.final_capt": "Purpose of the data"
    , "rgpd.final_answ": "Sending of information, newsletters and offers."
    , "rgpd.stora_capt": "Data storage"
    , "rgpd.stora_anws": "Database hosted in the EU, and with international management transfers to third countries."
    , "rgpd.right_capt": "Rights"
    , "rgpd.right_answ1": "At any time you can"
    , "rgpd.right_answ2": "limit, recover, rectify, delete and erase your information."
  },
  "es":{
    "title": "Contáctenos"
    , "fname": "Nombre"
    , "fcompany": [
      {"value": null, "text": "Seleccione tipo de Empresa", "disabled": true}
      , {"value": "Particular","text": "Particular"}
      , {"value": "Empresa","text": "Empresa"}
    ]
    , "fcompanySize": [
      {"value": null, "text": "Seleccione categoría de Empresa", "disabled": true}
      ,{"value": "Autonomo o Pequeña Empresa","text": "Autonomo o Pequeña Empresa"}
      ,{"value": "Mediana / Gran Empresa","text": "Mediana / Gran Empresa"}
      ,{"value": "Asesorías y Consultora","text": "Asesorías y Consultora"}
      ,{"value": "Otros","text": "Otros"}
    ]
    , "ftelef": "Telefono"
    , "femail": "Email"
    , "fcuidad": "Cuidad o Localidad"
    , "fcomentarios": "Cuéntanos en qué te podemos ayudar....."
    , "facept1": "He leído y acepto los términos "
    , "facept2": "de privacidad*"
    , "btnEnviar": "Enviar"
    , "sendOK": "Mensaje enviado"
    , "sendERROR": "Envio de mensaje fallido"
    , "message.rs": "Prácticas en empresas"
    , "rgpd.youcan": "Puedes consultar la información adicional y detallada sobre Protección de Datos en nuestra"
    , "rgpd.policy_capt": "política de privacidad"
    , "rgpd.resp_capt": "Responsable del tratamiento"
    , "rgpd.resp_answ": "Aicad Business School S.L."
    , "rgpd.final_capt": "Finalidad de los datos"
    , "rgpd.final_answ": "Envío de información, boletines de noticias y ofertas."
    , "rgpd.stora_capt": "Almacenamiento de los datos"
    , "rgpd.stora_anws": "Base de datos alojada en la UE, y con transferencias internacionales de gestión a terceros países."
    , "rgpd.right_capt": "Derechos"
    , "rgpd.right_answ1": "En cualquier momento puedes"
    , "rgpd.right_answ2": "limitar, recuperar, rectificar, suprimir y borrar tu información."
  }
}
</i18n>

<script>
export default {
    data() {
        return {
            web: window.location.href
            , form: {
                NOMBRE: ""
                , PARTICULAR_EMPRESA: null
                , TIPO_EMPRESA: null
                , SMS__COUNTRY_CODE: "+34"
                , SMS: ""
                , EMAIL: ""
                , CIUDAD: ""
                , sent_from_web: ""
                , sent_from_location: ""
                , COMENTARIOS: ""
                , RGPD_OPTIN: null
                , locate: this.$i18n.locale
            },
            sentSuccess: false,
            enviar: 0,
            code:[
                {value:"+34",text:"+34 ES"},
                {value:"+33",text:"+33 FR"},
                {value:"+91",text:"+91 IN"},
                {value:"+687",text:"+687 NC"},
                {value:"+689",text:"+689 PF"},
                {value:"+262",text:"+262 YT"},
                {value:"+508",text:"+508 PM"},
                {value:"+681",text:"+681 WF"},
                {value:"+352",text:"+352 LU"},
                {value:"+63",text:"+63 PH"},
                {value:"+27",text:"+27 ZA"},
                {value:"+64",text:"+64 NZ"},
                {value:"+420",text:"+420 CZ"},
                {value:"+31",text:"+31 NL"},
                {value:"+1",text:"+1 PR"},
                {value:"+41",text:"+41 CH"},
                {value:"+44",text:"+44 GB"},
                {value:"+230",text:"+230 MU"},
                {value:"+590",text:"+590 BL"},
                {value:"+594",text:"+594 GF"},
                {value:"+596",text:"+596 MQ"},
                {value:"+269",text:"+269 KM"},
                {value:"+971",text:"+971 AE"},
                {value:"+387",text:"+387 BA"},
                {value:"+880",text:"+880 BD"},
                {value:"+852",text:"+852 HK"},
                {value:"+32",text:"+32 BE"},
                {value:"+39",text:"+39 IT"},
                {value:"+213",text:"+213 DZ"},
                {value:"+49",text:"+49 DE"},
                {value:"+212",text:"+212 MA"},
                {value:"+86",text:"+86 CN"},
                {value:"+81",text:"+81 JP"},
                {value:"+216",text:"+216 TN"},
                {value:"+972",text:"+972 IL"},
                {value:"+30",text:"+30 GR"},
                {value:"+370",text:"+370 LT"},
                {value:"+60",text:"+60 MY"},
                {value:"+92",text:"+92 PK"},
                {value:"+7",text:"+7 RU"},
                {value:"+356",text:"+356 MT"},
                {value:"+20",text:"+20 EG"},
                {value:"+94",text:"+94 LK"},
                {value:"+886",text:"+886 TW"},
                {value:"+234",text:"+234 NG"},
                {value:"+62",text:"+62 ID"},
                {value:"+45",text:"+45 DK"},
                {value:"+98",text:"+98 IR"},
                {value:"+977",text:"+977 NP"},
                {value:"+90",text:"+90 TR"},
                {value:"+376",text:"+376 AD"},
                {value:"+507",text:"+507 PA"},
                {value:"+380",text:"+380 UA"},
                {value:"+598",text:"+598 UY"},
                {value:"+58",text:"+58 VE"},
                {value:"+84",text:"+84 VN"},
                {value:"+54",text:"+54 AR"},
                {value:"+52",text:"+52 MX"},
                {value:"+48",text:"+48 PL"},
                {value:"+386",text:"+386 SI"},
                {value:"+385",text:"+385 HR"},
                {value:"+47",text:"+47 NO"},
                {value:"+40",text:"+40 RO"},
                {value:"+46",text:"+46 SE"},
                {value:"+66",text:"+66 TH"},
                {value:"+56",text:"+56 CL"},
                {value:"+353",text:"+353 IE"},
                {value:"+421",text:"+421 SK"},
                {value:"+358",text:"+358 FI"},
                {value:"+61",text:"+61 AU"},
                {value:"+359",text:"+359 BG"},
                {value:"+36",text:"+36 HU"},
                {value:"+43",text:"+43 AT"},
                {value:"+57",text:"+57 CO"},
                {value:"+1",text:"+1 JM"},
                {value:"+595",text:"+595 PY"},
                {value:"+509",text:"+509 HT"},
                {value:"+995",text:"+995 GE"},
                {value:"+372",text:"+372 EE"},
                {value:"+593",text:"+593 EC"},
                {value:"+962",text:"+962 JO"},
                {value:"+973",text:"+973 BH"},
                {value:"+261",text:"+261 MG"},
                {value:"+65",text:"+65 SG"},
                {value:"+1",text:"+1 US"},
                {value:"+1",text:"+1 CA"},
                {value:"+371",text:"+371 LV"},
                {value:"+961",text:"+961 LB"},
                {value:"+590",text:"+590 FR"},
                {value:"+505",text:"+505 NI"},
                {value:"+351",text:"+351 PT"},
                {value:"+55",text:"+55 BR"},
                {value:"+370",text:"+370 LT"},
                {value:"+51",text:"+51 PE"},
                {value:"+974",text:"+974 QA"},
                {value:"+375",text:"+375 BL"},
                {value:"+233",text:"+233 GH"},
                {value:"+354",text:"+354 IS"},
                {value:"+243",text:"+243 CG"},
                {value:"+1",text:"+1 BS"},
                {value:"+503",text:"+503 SV"}
            ],
            url: "https://www.aicad.es/aviso-legal-privacidad/"
        }
    },
    computed: {
        title() {
            return this.$t("title");
        },
        fcompany() {
            return this.$t("fcompany");
        },
        fcompanySize() {
            return this.$t("fcompanySize");
        },
    },
    methods: {
        async enviarFormulario(){
            this.enviar = 0;      
            this.form.sent_from_web = window.location.href;
            this.form.sent_from_location = window.location.href;
            event.preventDefault();
            var send = "";
            var variant = 'default';
        
            let config = { 
                headers: {
                    'cache-control': 'no-cache',
                    'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            };
            let params = "body=" + JSON.stringify(this.form);
      
            const path = require('path');  
            const base = this.$router.options.base;
            let url = path.join(base, 'sendEmail.php');
      
            await this.axios.post(url, params, config)
                .then(response => {
                    this.sentSuccess = response.data.flag;
                    console.log(this.sentSuccess);
                    this.form = {
                        NOMBRE: ""
                        , PARTICULAR_EMPRESA: null
                        , TIPO_EMPRESA: null
                        , SMS__COUNTRY_CODE: "+34"
                        , SMS: ""
                        , EMAIL: ""
                        , CIUDAD: ""
                        , sent_from_web: ""
                        , sent_from_location: ""
                        , COMENTARIOS: ""
                        , RGPD_OPTIN: null
                        , locate: this.$i18n.locale
                    };
                    if(this.sentSuccess==true){
                        this.goTo();
                    }else{
                        send = this.$t('sendERROR');
                        this.$bvToast.toast(send, {
                            title: this.$t('message.rs'),
                            variant: variant,
                            autoHideDelay: 3000,
                            solid: true
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                }
                );
        },
        aceptPolitica(checked){
            this.enviar = (checked==1);
        },
        goTo(){
            localStorage.setItem('storedData', this.$router.currentRoute.name);
            this.$router.push({ name: 'thank' });
        }
    },
}
</script>

<style lang="scss">
#pcontact{
  .modal-dialog{
    width: auto !important;
  }
}  

#contacto{
  background: #1e9994;
  color: whitesmoke;
  a {
  color: whitesmoke !important;
  }
}

.buttonContacto{
  border: 2px solid #2c3e50;
  color: #2c3e50;
  padding: 0.5em 2em;
  font-weight: 700;
  background-color: transparent;
  transition: 0.3s;
}

.buttonContacto:hover{  
	opacity: .85;
	text-decoration: inherit !important;
	transform: scale(1.1);
  background-color: transparent;
  border: 2px solid #2c3e50;
  color: #2c3e50;
}
.rgpd {
  margin-top: 10px;
  text-align: left;
}
.rgpd p {
  margin: 0;
}
.rgpd p > a {
  text-decoration: none;
  color: rgb(20, 86, 139) !important;
}
.rgpd p > a:hover {
  text-decoration: underline;
  color: rgb(10, 57, 95) !important;
}
</style>